const actions = {
  drawer: {
    opened: 'drawer/opened',
    closed: 'drawer/closed'
  },
  filters: {
    setFilters: 'filters/set',
    setValue: 'filters/setValue',
    removeValue: 'filters/removeItem',
    save: 'filters/save',
    saveOneFiler: 'filters/saveOneFilter',
    dismiss: 'filters/dismiss',
    clearAll: 'filters/clearAll'
  }
};

export { actions };
